import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Gettingstartedpage1.css';

const Gettingstartedpage1 = () => {
  return (
    <div className="container my-5">
      <div className="text-start">
        <h2 className="fw-bold Heading">STARTING: IMPORTING ITEMS TO INDIA FROM CHINA</h2>
        <p>
          If your company has an asset-light model, importing from China to India can be profitable so you can
          concentrate on your core competencies. With LKR Imports & Exports, you can purchase a finished product, raw
          materials for manufacturing, or even an entire production line for a new factory setup.
        </p>
        <p>
          "It's going to be the end if we start concentrating on ourselves rather than our clients," he stated. "We need
          to do everything we can to postpone that day."Jeff Bezos
          <br />
          "Doing your best is not enough; you also need to know what to do and then do it."W. Edwards Deming
        </p>
        <p>
          Here is a detailed guide written by us, a Chinese import agency to India that has years of experience working
          with importers all over the world and exporters in China. Let's look at how to import goods into India from
          China and what you can do to help the process run more smoothly.
        </p>
      </div>

      <div className="p-4 my-4 rounded custom-card-one">
        <h4 className="fw-bold step-custom">Step 01 :</h4>
        <h5 className="fw-bold gs-que">Which product do you intend to bring into India from China?</h5>
        <p className='gs-text'>
          Importing can be quite simple, but it might be challenging to determine what kinds of things to bring into
          India from China. Before beginning to import from China to India, many of our clients already have a category
          or product in mind. For those who haven't decided yet, there are a few different approaches you can take.
        </p>
        <ul className='gs-points'>
          <strong>01.</strong> Go to China and do the research yourself.
          <br></br>
          <strong>02.</strong> Look up products on the internet.
          <br></br>
          <strong>03.</strong> Go to fairs and commercial exhibits.
          <br></br>
          <strong>04.</strong> The Best Chinese Factories can also make your unique product.
        </ul>
        <p className='gs-text'>
          <strong>Expert Tip: </strong>
          The best products to start with are those that you might readily sell with your current network. Identifying
          the initial product would be the most challenging, but it would be much simpler to refine your selections when
          you had practical experience.
        </p>
      </div>

      <div className="p-4 my-4 rounded custom-card-two">
        <h4 className="fw-bold step-custom">Step 02 :</h4>
        <h5 className="fw-bold gs-que">Verifying that they adhere to your nation's regulations</h5>
        <h5 className='gs-que1'>Verify your product's certifications and regulations before importing it into India from China.</h5>
        <p className='gs-text'>
          Make sure the products you intend to import from China to India meet Indian regulatory requirements.  Technical compliance programs include :
        </p>
        <ul className='gs-points'>
          <strong>01.</strong> ISI Product Certification
          <br></br>
          <strong>02.</strong> NABL Lab Recognition
          <br></br>
          <strong>03.</strong> Bureau of Indian Standards (BIS)
          <br></br>
          <strong>04.</strong> WPC Approval for Items with Wireless and/or Radio Features 
          <br></br>
          <strong>05.</strong> Food Safety Standards Authority of India (FSSAI)
          <br></br>
          <strong>06.</strong> Foreign Manufacturers Certification Scheme (FMCS) 
          <br></br>
          <strong>07.</strong> EPR is for Plastic, Electronic, and Battery Waste Management
          <br></br>
          <strong>08.</strong> LMPC stands for Legal Metrology for Packaged Commodities
        </ul>
        <p className='gs-text'>
        A startlingly high percentage of shipments of ostensibly harmless goods from China to India are 
        denied entry by customs every day because they do not comply with regulations.
        </p>
        <p className='gs-text'>
        Consider the possibility that your product could cause harm to a customer even if used improperly.  
        Containerisation and Labelling  Additionally, you must make sure that the packaging and labelling of your product adhere to the Indian Weights and Measures Act.  
        All finished products must have MRP or RSP stickers.  Making the label file in the.ai or.eps format makes it simple to make sure your labels are compliant. 
        Records   Certain goods need thorough documentation before they can be imported; after this is completed and approved by the local government, you can proceed.  
        Lab Examinations  Send samples to a NABL-accredited compliance testing business for testing if applicable to your product.  ARAI, ICAT for cars, and so forth.
        </p>
      </div>

      <div className="p-4 my-4 rounded custom-card-three">
        <h4 className="fw-bold step-custom">Step 03 :</h4>
        <h5 className="fw-bold gs-que"> Look for a Chinese provider</h5>
        <h5 className='gs-que1'> How Can I Locate the Best Chinese Supplier? </h5>
        <p className='gs-text'>
        Finding a Chinese supplier is the next step after choosing the goods.  
        Alibaba is the marketplace that most first-time importers visit, although there are other online market portals as well.  
        It's crucial to remember that Alibaba and other marketplaces aren't the real producers of the goods that are advertised on their portals. 
        The suppliers on the list may be manufacturers, distributors, or trade firms.
        </p>
      
        <p className='gs-text'>
          <strong>Expert Tip: </strong>
          Purchasing straight from a factory isn't always the best option. 
          In certain cases, our clients choose trading companies over manufacturers for a variety of reasons, such as higher MOQ, 
          flexibility, delivery time, or more.
        </p>

        <p className='gs-text'>
        It is crucial that you write a formal legal contract as an importer to protect yourself.  
        Often referred to as a supplier agreement, sales contract, production contract, or purchase agreement.  
        For this, consult a lawyer who specialises in commercial law in China.  
        Regretfully, the majority of small importers simply work on a proforma invoice provided by the source and never even consider this.
        </p>

        <p className='gs-text'>
        If there were problems, though, the majority of suppliers would still fix them and safeguard their brand. 
        However, if you intend to purchase a significant quantity from the supplier over time, it is not advised at all and you must obtain a formal legal contract.  
        If you desire IP protection, there are even additional legal requirements.  
        By giving us permission to import from China to India, we can ensure that you adhere to all rules established by our 
        internal staff and simplify the import and procurement process.
        </p>
      </div>

      <div className="p-4 my-4 rounded custom-card-four">
        <h4 className="fw-bold step-custom">Step 04 :</h4>
        <h5 className="fw-bold gs-que">Determine your items' landing cost.  </h5>
        <h5 className='gs-que1'>What is the price of importing goods into India from China? </h5>
        <p className='gs-text'>
        Checking the landing cost is a crucial next step after identifying possible Chinese suppliers and knowing the price.  
        The most crucial factor for the business's profitability is a feasibility analysis.  
        The cost of the goods plus the cost of shipping plus duties and taxes plus other costs incurred to ensure they can be imported can be used to calculate the landed cost.  
        To put it briefly, price includes all expenses from the factory floor to your home.  
        The bottom line profit of your business from importing from China to India is calculated using landed cost.
        </p>
        <p className='gs-text'>
          Expert Tip: 
          Purchasing straight from a factory isn't always the best option. 
          In certain cases, our clients choose trading companies over manufacturers for a variety of reasons, such as higher MOQ, 
          flexibility, delivery time, or more.
        </p>
        <ul className='gs-points'>
          <strong>01.</strong> Order value
          <br></br>
          <strong>02.</strong> CBM or box dimensions
          <br></br>
          <strong>03.</strong> The total order weight 
          <br></br>
          <strong>04.</strong> The HSN code 
          <br></br>
          <strong>05.</strong> Description of the product
          <br></br>
          <strong>06.</strong>  Air/Sea Mode If you have a proforma invoice and packing list, you can also share them.
          <br></br>
        </ul>
      </div>

      <div className="p-4 my-4 rounded custom-card-five">
        <h4 className="fw-bold step-custom">Step 05 :</h4>
        <h5 className="fw-bold gs-que">Verifying the order and sending it  </h5>
        <p className='gs-text'>For your import from China to India, we can offer you both air and sea services.</p>
        <p className='gs-text'>
        You must double-check all of the product specifications and quality requirements after the cost has been determined and you are satisfied to place an order or orders.  
        Informing the manufacturer that they will only accept the goods if they pass inspection or test labs, if appropriate, is also encouraged. 
        Verify that every element is included in the contract that the supplier will sign on your behalf.  
        You can employ our pre-shipment inspection service to have the quantity and quality of the goods checked once they are ready.  
        Once approved, you can either contact a goods moving company or leave the entire process to our experts.  
        Whether you're shipping by air or sea, we can get your goods to their destination. 
        </p>
        <p className='gs-text'>
          <strong>Expert Tip: </strong>
          When importing from China to India, cargo insurance is incredibly affordable when you consider the expenses that would arise if your package were to be lost or damaged during transit. 
          Our pricing are less complicated for you and are quite comparable to purchasing directly from an insurer.
        </p>
        <p className='gs-text'> <strong>Incoterms</strong>
        <br></br>
        The seller and the buyer must agree in writing on Incoterms, which are (eleven) standardised goods terms, or else the shipment will not be accepted by any air or ocean carrier.  
        For novices, they are a trap, and picking the incorrect one might have disastrous results.  When using Incoterms for the first time, follow:
        </p>
        <ul className='gs-points'>
          <strong>01.</strong> Ex Works (EXW): From factory pickup, you assume complete responsibility for planning, arranging, and paying as well as liable for any issues that arise.  
          Be careful to include a requirement in your purchase agreement that the supplier assist with truck loading. 
          <br></br>
          <strong>02.</strong>  Free To Carrier (FCA): After the shipment is turned over to the carrier, usually close to the port, you assume full obligation and responsibility. 
          <br></br>
          <strong>03.</strong>  Free On Board (FOB): As soon as the shipment passes over the ship's rail, you assume all obligation and responsibility.  
          Between delivery to the carrier and loading into the vessel, local fees should be paid. 
          <br></br>
        </ul>
      </div>

      <div className="p-4 my-4 rounded custom-card-six">
        <h4 className="fw-bold step-custom">Step 06 :</h4>
        <h5 className="fw-bold gs-que">Delivery to your warehouse after customs clearance.  </h5>
        <p className='gs-text'>We handle all of your imports from China to India, including customs clearance.
          <br></br> 
        Three categories are used by the Indian Trade Classification (ITC)-Harmonized System (HS) to classify goods:
        </p>
        <ul className='gs-points'>
          <strong>01.</strong> Restricted: Only after acquiring an import licence from the appropriate regional licensing authority can restricted items be imported. 
          <br></br>
          <strong>02.</strong> Goods that can only be imported through particular processes or modes of transportation are known as canalised goods. 
          <br></br>
          <strong>03.</strong> Prohibited: These are the products that are mentioned in ITC (HS) and are not allowed to be imported into India through any routes.
          <br></br>
        </ul>
        <p className='gs-text'>The process for clearing imported products after they reach the Indian port is as follows:
          <br></br>
          Bill of Entry: Evaluation of Declaration 
        </p>
        <ul className='gs-points'>
          <strong>01.</strong> Evaluation of EDI 
          <br></br>
          <strong>02.</strong> Inspection of the Green Channel facility for goods
          <br></br>
          <strong>03.</strong> Duty Payment and Bill of Entry Amendment (If Necessary)
          <br></br>
        </ul>
      </div>

      {/*part 2*/}
      <div className='custom-part2'>
      <div className="row g-4">
        {/* Top Row */}
        <div className="col-md-4">
          <div className="p-4">
            <h5 className="fw-bold gsp-que">Outlining The Initial Steps</h5>
            <p className='gsp-text'>
              Make an effort to write down every aspect of the product before
              creating the specifications. It could be as specific as the
              precise colour code you want your product to be created in or the
              quantity of screws you need. After you send them to us, we'll
              begin the sourcing process. To begin investing time in finding the
              finest supplier, we would need a $300 USD security deposit. You
              will receive a full refund for your initial order.
            </p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4">
            <h5 className="fw-bold gsp-que">How It Operates</h5>
            <p className='gsp-text'>
              For Novices and Start-ups Select the product you want to source,
              create a list of specifications, and send it to our qualified
              sourcing agent. They will help you make the complicated purchasing
              procedure easier. To make your decision easier, our knowledgeable
              agent will find the finest supplier that meets your product
              requirements and send you the best-filtered quotation.
            </p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4">
            <h5 className="gsp-que">Bundling Or A Number Of Products</h5>
            <h3 className='gsp-que1'>Seeking Assistance</h3>
            <p className='gsp-text'>
              Do you intend to purchase several items or have a product that
              will be built and packaged from several vendors? In this case, we
              would need you to provide us a list of the product or products you
              intend to buy. We will schedule your appointments with the
              possible suppliers, and you will need to travel to China.
            </p>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="col-md-4">
          <div className="p-4">
            <h5 className="gsp-que">Advanced Users Of Plant And Machinery</h5>
            <p className='gsp-text'>
              Obtaining raw materials, production lines, turnkey projects, and
              factory setup. We are able to source anything you require. Tell us
              what you want to manufacture, and we'll sift through the options
              to find the best hidden gem supplier for your upcoming project.
            </p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4">
            <h5 className="gsp-que">Are You Able To Prove The Best Price?</h5>
            <p className='gsp-text'>
              Guaranteed at the Correct Price Naturally, if the prices are not
              low, why would anyone source from China? We promise to give our
              customers the best price for their needs.
            </p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4">
            <h5 className="gsp-que">MOQ, Or Minimum Order Quantity</h5>
            <p className='gsp-text'>
              As long as the suppliers are prepared to provide the specified
              quantity, we do not require a Minimum Order Quantity (MOQ).
              However, customers who spend less than 8,000 USD typically don't
              place repeat orders.
            </p>
          </div>
        </div>
      </div>
      </div>

      <div className='faq-section'>
        <h4 className='gs-faq-heading'>Frequently Asked Questions</h4>
        <p className='gs-faq-que'>Q: What paperwork is needed to import products into India from China? </p>
        <p className='gs-faq-ans'> A : A commercial invoice, packing list, bill of lading/airway bill, import licence (if applicable), 
          and any other particular paperwork needed by Indian customs officials are among the necessary documents.
        </p>
        <p className='gs-faq-que'>Q: What is the duration required to import products into India from China? </p>
        <p className='gs-faq-ans'>A : A number of variables, including distance, customs clearance processes, and the mode of delivery (air or sea), can affect how long it takes to import goods.  
          Shipments by water usually take 15-30 days, whereas shipments by air usually take 3-5 days.
        </p>
        <p className='gs-faq-que'>Q: When importing goods from China to India, are there any limitations or forbidden items? </p>
        <p className='gs-faq-ans'>A: Importing goods into India from China is subject to a number of limitations and prohibitions.  Certain things are restricted or outright forbidden, including weapons, explosives, drugs, fake commodities, and specific agricultural products. 
           To prevent any problems, it is crucial that you get familiar with the particular legislation.
        </p>
        <p className='gs-faq-que'>Q: Do I need an Import-Export Code (IEC) to import goods from China to India?</p>
        <p className='gs-faq-ans'>
        A: Yes, an Import-Export Code (IEC) is mandatory for any person or entity wanting to import goods into India. 
        You can apply for an IEC online through the Directorate General of Foreign Trade (DGFT) website or we can help you Import Goods from China to India.
        </p>
        <p className='gs-faq-que'>Q : What taxes and customs fees are associated with bringing products into India from China?</p>
        <p className='gs-faq-ans'>
        A: The sort of products being imported and their corresponding Harmonised System (HS) codes determine the customs charges and levies.  There may be levies such as the Integrated Goods and Services Tax (IGST), basic customs duty, and others.  
        To find out the precise rates that apply to your product type, speak with our staff or ask a customs department for advice.
        </p>
        <p className='gs-faq-que'>Q : Can I purchase personal items from China?</p>
        <p className='gs-faq-ans'>
        A : As long as you pay the necessary charges, taxes, and fees and abide by the customs laws, you are free to import products from China for your own use.  
        Certain commodities, such electronics or expensive things, can, however, have extra requirements or quantity restrictions.
        </p>
        <p className='gs-faq-que'>Q: Do I need to work with an agency or middleman to import items from Chinese producers directly? </p>
        <p className='gs-faq-ans'>
        A: Direct imports from Chinese manufacturers are feasible.  Working with an experienced sourcing agent like LKR Imports & Exports, 
        who can assist in navigating the complexity of international trade, might be helpful if you are not familiar with the import procedure.
        </p>
        <p className='gs-faq-que'>Q: How can I make sure that the products I import from China are of high quality? </p>
        <p className='gs-faq-ans'>
        A: Research and choose reliable suppliers who have a history of producing high-quality goods; ask for product samples before placing large orders to assess their quality; 
        use third-party inspection agencies to perform quality checks during production and prior to shipping; 
        communicate your quality requirements and specifications to the supplier; and create a quality control agreement.
        </p>
        <p className='gs-faq-que'>Q : When importing items from China, what are the standard terms of payment? </p>
        <p className='gs-faq-ans'>
        A: When purchasing goods from China, the following payment methods are most frequently used: 
        A payment option that provides protection for both importers and exporters is the Letter of Credit (LC). 
        </p>
        <ul className='gs-faq-ans'>
          <li>By using a bank to process the money, the exporter is guaranteed to receive it once the requirements are fulfilled.</li>
          <li>Directly moving money from the importer's bank account to the exporter's bank account is known as a telegram transfer (TT) or wire transfer.</li>
          <li>PayPal and Escrow are online payment systems that offer safe transactions and buyer protection.</li>
        </ul>
      </div>

    </div>

  );
};

export default Gettingstartedpage1;

